import type { BusinessData } from 'types/business'
import type {
  Campaign,
  CampaignData,
  CampaignFooter,
  EmailElement,
} from 'types/content-editor'
import { ENTITY_TYPE } from '@disco/constants/content-editor'
import { generateMjml } from './mjml'
import {
  DEFAULT_CAMPAIGN_TEMPLATE_ID,
  defaultCampaignTemplate,
  templates,
} from './templates'
import { generateText } from './text'

const generateMarkup = (
  campaign: Campaign,
  data: CampaignData,
  businessSettings: BusinessData | null | undefined,
  footer: CampaignFooter | null | undefined,
): Array<string> => [
  generateMjml(campaign, data, businessSettings, footer),
  generateText(campaign, data, businessSettings, footer),
]

const getContentBlocks = (campaign: Campaign): EmailElement[] => {
  const result: EmailElement[] = []
  campaign.sections.forEach(s => {
    s.columns.forEach(c => result.push(...(c.columnContent || [])))
  })
  return result
}

export const containsMergeTags = (campaign: Campaign): boolean => {
  let result = false
  const textBlocks = getContentBlocks(campaign).filter(b => b.type === 'text')
  textBlocks.forEach(textBlock => {
    if (
      textBlock.type === 'text' &&
      textBlock.content &&
      textBlock.content.entityMap
    ) {
      for (const key in textBlock.content.entityMap) {
        if (textBlock.content.entityMap[key].type === ENTITY_TYPE.MERGE_TAG)
          result = true
      }
    }
  })
  return result
}
export {
  DEFAULT_CAMPAIGN_TEMPLATE_ID,
  defaultCampaignTemplate,
  generateMarkup,
  generateMjml,
  generateText,
  templates,
}
